import { Form } from "react-router-dom"
import { useActionData, useNavigation, Link } from 'react-router-dom';
import AdminTournamentsForm from '../../components/admin/AdminTournamentsForm.jsx'
import AdminTournamentsShow from '../../components/admin/AdminTournamentsShow.jsx'
import { CreateTournament } from "../../repo/TournamentsRepo.js";

export default function TournamentNewPage() {
  const response = useActionData()
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminTournamentsShow tournament={response.data} status="created"/>
      ) : (
        <>
          <h1>Create New Tournament</h1>
          <div id="tournament-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="POST" className="space-y-4 md:space-y-6 mt-4">
              <AdminTournamentsForm errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>
            </Form>
          </div>

          <div id="tournaments" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to="/cocofantoelefanto/tournaments">Back to Tournaments</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const tournament = {
    name: data.get('name'),
    edition: data.get('edition'),
    starts_at: data.get('starts_at'),
    ends_at: data.get('ends_at'),
    third_party_label: data.get('third_party_label'),
    third_party_id: data.get('third_party_id'),
    third_party_season: data.get('third_party_season'),
    tournament_standings: {
      rules: data.get('tournament_standings_rules'),
      content: data.get('tournament_standings_content'),
    }
  }

  return await CreateTournament(tournament)
}
